// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","primaryColor":"#3A237B","h3":"GolfCourseAgreement_h3__lNPMz","h4":"GolfCourseAgreement_h4__d-GMq"};